'use client';

import { LINK } from '@constants';
import { useReportBoundaryError } from '@smiledragon-corp/signoz-nextjs/react';
import { Box } from '@viewup/ui';
import { NetworkError } from 'viewup-lib/common';
import { ErrorTemplate } from './_components/ErrorTemplate';

const GlobalError = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useReportBoundaryError(error, { source: 'global-error-boundary' });

  if (error instanceof NetworkError) {
    return (
      <html>
        <body>
          <Box height='100svh' pt={64} style={{ margin: '0 auto', maxWidth: 440 }} width='100%'>
            <ErrorTemplate
              errorHandleButtonText='메인페이지로 돌아가기'
              onClickErrorHandle={() => {
                window.location.href = LINK.HOME;
              }}
              title={'네트워크 오류가 발생했습니다.'}
            />
          </Box>
        </body>
      </html>
    );
  }
  return (
    <html>
      <body>
        <Box height='100svh' pt={64} style={{ margin: '0 auto', maxWidth: 440 }} width='100%'>
          <ErrorTemplate
            errorHandleButtonText='메인페이지로 돌아가기'
            onClickErrorHandle={() => {
              window.location.href = LINK.HOME;
            }}
            title={'일시적인 오류가 발생했습니다.'}
          />
        </Box>
      </body>
    </html>
  );
};

export default GlobalError;
